import { render, staticRenderFns } from "./FloatingDocumentViewer.vue?vue&type=template&id=97980c28&scoped=true"
import script from "./FloatingDocumentViewer.vue?vue&type=script&lang=js"
export * from "./FloatingDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./FloatingDocumentViewer.vue?vue&type=style&index=0&id=97980c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97980c28",
  null
  
)

export default component.exports